<template>
  <div class="wrapper pt-5" :id="'lifeStyle' + componentId">
    <div class="container-fluid pl-0">
      <div>
        <p><span class="yellow_chip">Life Style/Personal History</span></p>
        <ul class="list-group colcount2">
          <li class="list-group-item">
            <input class="form-check-input me-1" type="checkbox" value=""
              :id="'lifeStyle-firstCheckbox' + propsData.componentId" />
            <label class="form-check-label" :for="'lifeStyle-firstCheckbox' + propsData.componentId">Alcohol
              intake</label>
          </li>
          <li class="list-group-item">
            <input class="form-check-input me-1" type="checkbox" value="" id="secondCheckbox" />
            <label class="form-check-label" for="secondCheckbox">No smoking
            </label>
          </li>
          <li class="list-group-item">
            <input class="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox" />
            <label class="form-check-label" for="thirdCheckbox">Tobacco chewing</label>
          </li>
          <li class="list-group-item">
            <input class="form-check-input me-1" type="checkbox" value="" id="fourthCheckbox" />
            <label class="form-check-label" for="thirdCheckbox">Vegetarian</label>
          </li>
          <li class="list-group-item">
            <input class="form-check-input me-1" type="checkbox" value="" id="fourthCheckbox" />
            <label class="form-check-label" for="thirdCheckbox">Non-vegetarian</label>
          </li>
          <li class="list-group-item">
            <input class="form-check-input me-1" type="checkbox" value="" id="fourthCheckbox" />
            <label class="form-check-label" for="thirdCheckbox">Married</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!--wrapper-->
</template>
<script setup>
import { ref, onMounted, defineProps, watch } from "vue";
let propsData = defineProps({
  componentId: {
    default: "",
  },
});
onMounted(() => {
  $(document).ready(function () {
    let selectedIndex = 0; // To keep track of the selected index

    function handleArrowKeys(event) {
      const rows = $('#lifeStyle' + propsData.componentId).find("input");
      if (event.key === "ArrowDown" && selectedIndex < rows.length) {
        selectedIndex++;
      } else if (event.key === "ArrowUp" && selectedIndex > 0) {
        selectedIndex--;
      }
      // console.log('selectedIndex: ', selectedIndex);

      // Update the selected row
      // console.log('rows: ', rows);
      rows[selectedIndex - 1]?.focus()
      // rows.each((index, row) => {
      // });
    }
    document.getElementById('lifeStyle' + propsData.componentId).addEventListener('keydown', function (e) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault()
        e.stopPropagation()
        handleArrowKeys(e)
      }
    });
  });
  document.getElementById('lifeStyle-firstCheckbox' + propsData.componentId).focus()
})
</script>